import { Box as e, Chip as t, DropdownButton as n, FlexBox as r, Icon as i, Text as a } from "@dixa/lib-shared-habla";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { createContext as c, useContext as l } from "react";
import u from "classnames";
var d = {
	chip: "_chip_yctch_2",
	panel: "_panel_yctch_16"
}, f = c(void 0), p = f.Provider;
function m() {
	return l(f);
}
//#endregion
//#region ../utils/src/components/sourceConversations/sourceConversationsChip.tsx
function h({ conversations: c, className: l }) {
	let f = m();
	return !f || !c?.length ? null : /* @__PURE__ */ o(n, {
		noStyle: !0,
		fixed: !0,
		buttonProps: { "aria-label": "Show source conversations" },
		dropdown: /* @__PURE__ */ s(e, {
			className: d.panel,
			width: "480px",
			maxHeight: "480px",
			padding: "300 400",
			background: "neutral.000",
			style: { overflowY: "auto" },
			children: [/* @__PURE__ */ o(a.Heading, {
				variant: "heading-2",
				children: "Conversations"
			}), f(c)]
		}),
		children: /* @__PURE__ */ o(t, {
			noBorder: !0,
			className: u(d.chip, l),
			children: /* @__PURE__ */ s(r, {
				alignItems: "center",
				gap: "100",
				children: [/* @__PURE__ */ o(i, { name: "chat" }), c.length]
			})
		})
	});
}
//#endregion
export { p as n, h as t };

//# sourceMappingURL=sourceConversations-BdZZWFvt.js.map